import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import SaleDisplayTable from './SaleDisplayTable';
import SaleDisplayHeader from './SaleDisplayHeader';
import services from './../../store/services';
import SaleDisplayBottom from "./SaleDisplayBottom";
import { HubConnectionBuilder } from '@aspnet/signalr';
//import { connect } from 'net';

const maxRowsForTable = 12;

const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1,
        margin: 5,
    },
    paper: {
        padding: theme.spacing(2),
        textAlign: 'center',
        color: theme.palette.text.secondary,
    },
    link: {
        margin: theme.spacing(1),
    },
    container: {
        alignItems: "center",
        display: "flex-grow",
    },
    item: {

    }
}));

const initFilters = {
    saleid: 'e7f320b2-334c-e911-80f3-0050568b4c0b',
    roomNo: '',
    saleDisplayType: '',
    awex: true,
    seller: '',
    buyer: '',
    missing: false,
    WD: '',
    NB: '',
    Sale: '',
    Transfer: false
};

function SaleResultsDisplay(props) {
    const classes = useStyles();
    const [rows, setRows] = useState([]);
    const [selectedRow, setSelectedRow] = useState({});

    updateInitial(props);
    
    const [SaleIdSelectValue, setSaleIdSelectValue] = useState(initFilters.saleid);
    const [RoomNo, setRoomNo] = useState(initFilters.roomNo);
    const [saleDisplayType, setSaleDisplayType] = useState(initFilters.saleDisplayType);
    const [ckAWEX, setCkAWEX] = useState(initFilters.awex);
    const [seller, setSeller] = useState(initFilters.seller);       
    const [buyer, setBuyer] = useState(initFilters.buyer);
    const [missing, setMissing] = useState(initFilters.missing);
    const [WD, setWD] = useState(initFilters.WD);
    const [NB, setNB] = useState(initFilters.NB);
    const [Sale, setSaleI] = useState(initFilters.Sale);
    const [Transfer, setTransfer] = useState(initFilters.Transfer);

    const [srConnection, setSRConnection] = useState(null);
    const [lastUpdate, setLastUpdate] = useState(null);

    function updateInitial(props) {
        const params = props.match.params;
        if (!params.saleid) {
            return;
        }
        //console.log(props);
        initFilters.saleid = params.saleid;
        initFilters.roomNo = params.roomNo && params.roomNo > 0 ? params.roomNo : '';
        initFilters.saleDisplayType = params.saleDisplayType && params.saleDisplayType > 0 && params.saleDisplayType != '100000001' ? params.saleDisplayType : ''; 
        initFilters.awex = (params.awex ==='true'); 
        initFilters.seller = (params.seller !== "-1") ? params.seller : '';
        initFilters.buyer = (params.buyer !== "-1") ? params.buyer : '';
        initFilters.missing = (params.missing === 'true');
        initFilters.WD = (params.WD !== "-1") ? params.WD : '';
        initFilters.NB = (params.NB !== "-1") ? params.NB : '';
        initFilters.Sale = (params.Sale !== "-1") ? params.Sale : '';
        initFilters.Transfer = (params.Transfer !== "-1") ? params.Transfer : '';
    }

    const updateTable = (data) => {
        if (data && data.length > 0) {
            const preparedData = data.slice(0, maxRowsForTable);
            setRows(preparedData);
            const found = preparedData.find(curRow => !curRow.salesTransactionEventId);
            setSelectedRow(found ? found : {});

        } else {
            setRows([]);
            setSelectedRow({});
        }
    }

    const getLots = () => {
        let query = `saleDayId=${encodeURI(SaleIdSelectValue)}&awexOnly=${encodeURI(ckAWEX)}`;
        if (RoomNo) {
            query = query + "&roomNo=" + encodeURI(RoomNo)
        }
        if (seller !== "-1") {
            query = query + "&seller=" + encodeURI(seller)
        }
        if (buyer !== "-1") {
            query = query + "&buyer=" + encodeURI(buyer)
        }

        // AP-2668
        //if (missing) {
        //    query = query + "&missing=" + encodeURI(missing)
        //}
        ////sales results
        //if (WD === "WD" || NB === "NB" || Sale === "S" || Transfer === "TR") {
        //    let outcome = "";
        //    if (WD === "WD") {
        //        outcome += "WD,";
        //    }
        //    if (NB === "NB") {
        //        outcome += "NB,";
        //    }
        //    if (Sale === "S") {
        //        outcome += "S,";
        //    }
        //    if (Transfer === "TR") {
        //        outcome += "TR";
        //    }

        //    //remove the last char if it's ","
        //    if (outcome !== "" && outcome.slice(-1) === ",") {
        //        outcome = outcome.substring(0, outcome.length - 1);
        //    }
        //    if (outcome !== "")
        //        query += "&outcome=" + outcome;
        //}

        setLastUpdate(new Date());

        services.getLots(query).then(response => {
            updateTable(response.data);
        });
    }
    
    const startSRConnection = (connection, needToBeUpdated) => {
        // connection could be stopped because of cleanup
        if (!connection || connection.closedCallbacks.length === 0) {
            return;
        }

        connection.start()
            .then(() => connection.invoke("ApplySaleIdSelectValue", SaleIdSelectValue)) // if we need to know SaleIdSelectValue from frontend
            .catch(err => console.error('SR connection Error: ', err));
        if (needToBeUpdated) {
            getLots();
        }
    }; 

    const createSRConnection = () => {
        if (!srConnection) {
            let connection = new HubConnectionBuilder()
                .withUrl("/lpbnotificationhub")
                //.withAutomaticReconnect()
                .build();
            connection.on("UpdateSaleDisplay", data => {
                getLots();
            });
            setSRConnection(connection);
        }
    }

    const cleanSRUp = () => {
        if (srConnection) {
            srConnection.closedCallbacks = [];
            srConnection.stop();
        }
    };
    
    useEffect(() => {
        if (srConnection) {
            // re-establish the connection if connection dropped
            srConnection.onclose(
                () => setTimeout(startSRConnection, 5000, srConnection, true)
            );
            startSRConnection(srConnection, false);
        }
        return cleanSRUp;
    }, [srConnection]);

    useEffect(() => {
        createSRConnection();
        getLots();
    }, [RoomNo, SaleIdSelectValue, ckAWEX, seller, buyer, missing, WD, NB, Sale,Transfer]);

    return (
        <div className={classes.root}>
            <SaleDisplayHeader selectedRow={selectedRow} saleDisplayType={saleDisplayType} roomNo={RoomNo} />
            <SaleDisplayTable rows={rows} selectedRow={selectedRow} />
            <SaleDisplayBottom saleDisplayType={saleDisplayType} saleIdSelectValue={SaleIdSelectValue} ckAWEXSelectedValue={ckAWEX} sellerSelectedValue={seller} buyerSellectedValue={buyer} roomNo={RoomNo} lastUpdate={lastUpdate} />
        </div>);
}
export default SaleResultsDisplay;